import {
  addNavMenuItem,
  addNavMenuSection,
  addActionBarItem,
  registerDataTableComponent,
  registerPageTab,
  PageLocationId,
} from "@bb-vendure/admin-ui/core";
import { requestOrderDetail } from "./components/request-order";
import { RefundStateColumnComponent } from "./components/refund-state-column/refund-state-column.component";
import RequestRefundTableComponent from "./components/request-refund-list/request-refund-list.component";
import RequestRefundFromCustomerTableComponent from "./components/from-customer-list/home.component";

export default [
  addNavMenuItem(
    {
      id: "refund-nav",
      label: "nav.refund-requests",
      routerLink: ["/extensions/refund"],
      icon: "hard-drive-disks",
    },
    "sales"
  ),

  registerPageTab({
    location: "refund-request-list" as PageLocationId,
    tab: "common.all-requests",
    route: "/extensions/refund",
    //tabIcon: "star",
    component: RequestRefundTableComponent,
  }),

  registerPageTab({
    location: "refund-request-list" as PageLocationId,
    tab: "common.from-admin",
    route: "/extensions/refund/from-admin",
    //tabIcon: "star",
    component: RequestRefundTableComponent,
  }),

  registerPageTab({
    location: "refund-request-list" as PageLocationId,
    tab: "common.from-customer",
    route: "/extensions/refund/from-customer",
    //tabIcon: "star",
    component: RequestRefundFromCustomerTableComponent,
  }),

  registerDataTableComponent({
    component: RefundStateColumnComponent,
    tableId: "order-list",
    columnId: "refundStatus",
  }),

  addActionBarItem({
    id: "refund-order-button",
    label: "common.request-refund",
    locationId: "order-detail",
    onClick: (event, context) => requestOrderDetail(context),
  }),
];
